"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 25 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12.34 21.002A9.065 9.065 0 0 1 3.19 12a9.065 9.065 0 0 1 9.15-9 9.192 9.192 0 0 1 6.447 2.661l-4.413 4.34h10.167v-10l-3.579 3.518A12.312 12.312 0 0 0 12.34 0 12.094 12.094 0 0 0 .152 12 12.094 12.094 0 0 0 12.34 24a12.1 12.1 0 0 0 11.99-10h-3.082a9.124 9.124 0 0 1-8.908 7.002Z"
  })]
});